import React from 'react';

interface AboutCTASectionProps {
  language?: 'ar' | 'en';
  titleAr?: string;
  titleEn?: string;
  descriptionAr?: string;
  descriptionEn?: string;
  buttonTextAr?: string;
  buttonTextEn?: string;
  backgroundImage?: string;
  backgroundAlt?: string;
}

const AboutCTASection: React.FC<AboutCTASectionProps> = ({
  language = 'ar',
  titleAr = "جاهزون لتحقيق رؤيتكم…",
  titleEn = "Ready to build your vision?",
  descriptionAr = "تواصل معنا اليوم لبدء مشروعك مع مكة البركة للمقاولات.",
  descriptionEn = "Contact us today to start your project with Mecca El Baraka For Construction.",
  buttonTextAr = "تواصل معنا",
  buttonTextEn = "Contact Us",
  backgroundImage = "/images/about-cta.jpg",
  backgroundAlt = ""
}) => {
  const isRTL = language === 'ar';

  return (
    <section className="relative py-16 bg-gradient-to-br from-blue-900 via-blue-800 to-gray-900 text-white text-center">
      <div className="container-custom relative z-10">
        <h2 
          className="text-3xl md:text-4xl font-bold mb-4"
          data-editable="true"
          data-text-key="titleAr"
        >
          {isRTL ? titleAr : titleEn}
        </h2>
        <p 
          className="text-lg mb-6"
          data-editable="true"
          data-text-key="descriptionAr"
        >
          {isRTL ? descriptionAr : descriptionEn}
        </p>
        <a 
          href="/contact" 
          className="btn-primary text-lg font-semibold inline-block px-8 py-3 rounded-full shadow-lg"
          data-editable="true"
          data-text-key="buttonTextAr"
        >
          {isRTL ? buttonTextAr : buttonTextEn}
        </a>
      </div>
      <img 
        src={backgroundImage} 
        alt={backgroundAlt || ""} 
        className="absolute inset-0 w-full h-full object-cover opacity-20 z-0"
        data-editable="true"
        data-image-key="backgroundImage"
        data-image-alt-key="backgroundAlt"
      />
    </section>
  );
};

export default AboutCTASection; 